import Dialog from "@mui/material/Dialog";
import styles from "./HelpAndSupportDialog.module.scss";
import Clear from "@mui/icons-material/Clear";
import DownloadButton from "../../imgs/download.svg";
import { withTranslation } from "react-i18next";
import React from "react";
import HelpAndSupportClient from "../clients/HelpAndSupportClient";
import { base64FileDownload } from "../../utils/FileDownloadUtil";
import withStyles from '@mui/styles/withStyles';

const StyledDialog = withStyles({
  paper: {
    width: 600,
    maxWidth: 600,
  },
})(Dialog);

function HelpAndSupportDialog(props) {
  function downloadFile() {
    HelpAndSupportClient.getFAQs(props.user)
      .then((response) => {
        base64FileDownload(response, "application/pdf", "USA-FAQs.pdf");
      })
      .catch();
  }

  return (
    <StyledDialog open={props.open}>
      <div className={styles.wrapper}>
        <button className={styles.close} onClick={props.closeModal}>
          <Clear />
        </button>
        <div className={styles.header}>{props.t("Footer.help")}</div>
        <div className={styles.description}>
          {props.t("Footer.description")}
        </div>
        <button className={styles.downloadButton} onClick={downloadFile}>
          <img src={DownloadButton} />
          <span>{props.t("Footer.downloadFAQs")}</span>
        </button>
        <div className={styles.contactHeader}>
          {props.t("Footer.contactHeader")}
        </div>
        <div className={styles.contactInfoContainer}>
          <div className={styles.contactInfo}>
            <div>{props.t("Footer.byEmail")}</div>
            <a href="mailto:dlrcon@ford.com" className={styles.email}>
              dlrcon@ford.com
            </a>
          </div>
          <div className={styles.contactInfo}>
            <div>{props.t("Footer.byPhone")}</div>
            <div>1-800-790-4357 opt 2, 2</div>
          </div>
        </div>
        <div className={styles.operationInfo}>
          {props.t("Footer.hoursOfOperation")}
        </div>
      </div>
    </StyledDialog>
  );
}

export default withTranslation("emp")(HelpAndSupportDialog);
